<template>
	<button
		:class="['dc-post-grid-load-more', 'dc-button', { loading }]"
		@click.stop.prevent="loadMore()"
		>{{ label }}</button
	>
</template>

<script>
import { Translatable } from '@dc-post-grid/mixins/Translatable';
export default {
	mixins: [Translatable],
	props: {
		loading: {
			type: Boolean,
			required: true,
		},
		searchButtonId: {
			type: String,
			required: true,
		},
		currentPaged: {
			type: Number,
			required: true,
		},
		totalPages: {
			type: Number,
			required: true,
		},
	},
	computed: {
		label() {
			return this.loading ? this.dctxt('loading') : this.dctxt('loadMore');
		},
	},
	methods: {
		loadMore() {
			const tmpCurrentPaged = parseInt(this.currentPaged) + 1;
			this.$emit('update-current-paged', tmpCurrentPaged);
		},
	},
};
</script>
